import { Component } from '@angular/core';
import { BreadcumbsLinks } from '@maced/angular-components/lib/breadcrumbs/breadcrumbs-interface';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent {
  iconLable:string = 'breadcrumb overflow option';
  breadCrumbLimit: number = 20;
  isLinksClickable: boolean = false;
  nextIconClass: string = 'icon-chevron-slash';
  numberOfLinksVisible1 = 1;
  numberOfLinksVisible3 = 3;
  numberOfLinksVisible8 = 3;
  breadcrumbsContainer1: string = 'breadcrumbsContainer1';
  breadcrumbsContainer2: string = 'breadcrumbsContainer2';
  breadcrumbsContainer3: string = 'breadcrumbsContainer3';
  breadcrumbsContainer4: string = 'breadcrumbsContainer4';
  breadcrumbsContainer5: string = 'breadcrumbsContainer5';
  breadcrumbsContainer6: string = 'breadcrumbsContainer6';
  breadcrumbsContainer7: string = 'breadcrumbsContainer7';
  breadcrumbsContainer8: string = 'breadcrumbsContainer8';
  breadcrumbsContainer9: string = 'breadcrumbsContainer9';
  breadcrumbsContainer10: string = 'breadcrumbsContainer10';
  breadcrumbsContainer11: string = 'breadcrumbsContainer11';
  breadcrumbsContainer12: string = 'breadcrumbsContainer12';
  breadcrumbsContainer13: string = 'breadcrumbsContainer13';

  linksData: BreadcumbsLinks[] = [
    {id: '1', name: 'Level one', label: 'Level one', targetUrl: '/card'},
    {id: '2', name: 'Level two', label: 'Level two', targetUrl: '/button'},
    {id: '3', name: 'Level three', label: 'Level three', targetUrl: '/navbar'},
    {id: '4', name: 'Level four', label: 'Level four', targetUrl: '/button'},
    {id: '5', name: 'Level five', label: 'Level five', targetUrl: '/navbar'},
  ];

  linksData3: BreadcumbsLinks[] = [
    {id: '1', name: 'Nivel uno', label: 'Nivel uno', targetUrl: '/card'},
    {id: '2', name: 'Nivel dos', label: 'Nivel dos', targetUrl: '/button'},
    {id: '3', name: 'Nivel tres', label: 'Nivel tres', targetUrl: '/navbar'},
    {id: '4', name: 'Nivel cuatro', label: 'Nivel cuatro', targetUrl: '/button'},
    {id: '5', name: 'Nivel  cinco', label: 'Nivel cinco', targetUrl: '/navbar'},
  ];

  linksData4: BreadcumbsLinks[] = [
    {id: '1', name: 'पहला स्तर', label: 'पहला स्तर', targetUrl: '/card'},
    {id: '2', name: 'स्तर दो', label: 'स्तर दो', targetUrl: '/button'},
    {id: '3', name: 'स्तर तीन', label: 'स्तर तीन', targetUrl: '/navbar'},
    {id: '4', name: 'स्तर चार', label: 'स्तर चार', targetUrl: '/button'},
    {id: '5', name: 'स्तर पांच', label: 'स्तर पांच', targetUrl: '/navbar'},
  ];
  
  linksData8: BreadcumbsLinks[] = [
    {id: '1', name: 'Level one', label: 'Level one', targetUrl: '/card'},
    {id: '2', name: 'Level two', label: 'Level two', targetUrl: '/button'},
    {id: '3', name: 'Level three', label: 'Level three', targetUrl: '/navbar'},
    {id: '4', name: 'Level four', label: 'Level four', targetUrl: '/button'},
  ];

  linksData10: BreadcumbsLinks[] = [
    {id: '1', name: 'Level one', label: 'Level one with the breadcrumb limit 20', targetUrl: '/card'},
    {id: '2', name: 'Level two', label: 'Level two with the breadcrumb limit 20', targetUrl: '/button'},
    {id: '3', name: 'Level three', label: 'Level three with the breadcrumb limit 20', targetUrl: '/navbar'},
    {id: '4', name: 'Level four', label: 'Level four with the breadcrumb limit 20', targetUrl: '/button'},
  ];
}
